import { IssueDetail } from '@/entities/issue/v2';

export enum breadcrumbTypes {
  inspection = 'inspection',
  page = 'page',
  section = 'section',
  conditionalSection = 'conditional_section',
  question = 'question',
}

const isSection = (type: string) => type === breadcrumbTypes.section || type === breadcrumbTypes.conditionalSection;

const hasBreadcrumb = (issue: IssueDetail) => {
  return issue.data.payload?.breadcrumb !== undefined;
};

export const getInspectionId = (issue: IssueDetail) => {
  if (hasBreadcrumb(issue)) {
    return issue.data.payload?.inspection_id || null;
  }

  return null;
};

export const getInspectionTitle = (issue: IssueDetail) => {
  if (!hasBreadcrumb(issue)) {
    return '-';
  }

  const title = issue.data.payload?.breadcrumb!
    .find(breadcrumb => breadcrumb.type === breadcrumbTypes.inspection)?.title ?? '-';

  return title === '' ? '-' : title;
};

export const getPageTile = (issue: IssueDetail) => {
  if (!hasBreadcrumb(issue)) {
    return '-';
  }

  const title = issue.data.payload?.breadcrumb!
    .find(breadcrumb => breadcrumb.type === breadcrumbTypes.page)?.title ?? '-';

  return title === '' ? '-' : title;
};

export const getFirstSection = (issue: IssueDetail) => {
  if (!hasBreadcrumb(issue)) {
    return '-';
  }

  const title = issue.data.payload?.breadcrumb!
    .find(breadcrumb => isSection(breadcrumb.type))?.title ?? '-';

  return title === '' ? '-' : title;
};

export const getQuestion = (issue: IssueDetail) => {
  if (!hasBreadcrumb(issue)) {
    return '-';
  }

  let question = null;
  issue.data.payload?.breadcrumb!.forEach(breadcrumb => {
    if (breadcrumb.type === breadcrumbTypes.question) {
      question = breadcrumb.title;
    } else if (breadcrumb.parent && breadcrumb.parent.type === breadcrumbTypes.question) {
      question = breadcrumb.parent.title;
    }
  });

  if (question === null) {
    return '-';
  }

  return question === '' ? '-' : question;
};

export const getResponse = (issue: IssueDetail) => {
  if (!hasBreadcrumb(issue)) {
    return '-';
  }

  let response = null;
  issue.data.payload?.breadcrumb!.forEach(breadcrumb => {
    if (breadcrumb.type === breadcrumbTypes.question) {
      response = breadcrumb.response?.join(', ');
    } else if (breadcrumb.parent && breadcrumb.parent.type === breadcrumbTypes.question) {
      response = breadcrumb.parent.response?.join(', ');
    }
  });

  if (response === null) {
    return '-';
  }

  return response === '' ? '-' : response;
};
